import { useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "../styles/Pagination.css";

const PaginationCustom = ({
    totalItems = 0,
    totalPages = 0,
    currentPage = 1,
    setCurrentPage,
    limit,
    setLimit,
    showLimit = true,
    className = "",
    limitOptions = [10, 20, 50, 100]
}) => {
    const [visiblePages, setVisiblePages] = useState([]);
    const normalizedCurrentPage = currentPage > 0 ? currentPage : 1;
    const normalizedTotalPages = Math.max(Number(totalPages) || 0, 0);
    const isPreviousDisabled = normalizedCurrentPage <= 1;
    const isNextDisabled = normalizedTotalPages <= 1 || normalizedCurrentPage >= normalizedTotalPages;

    useEffect(() => {
        updateVisiblePages(normalizedCurrentPage);
    }, [normalizedCurrentPage, normalizedTotalPages]);

    useEffect(() => {
        if (typeof setCurrentPage !== "function" || normalizedTotalPages <= 0) return;

        if (normalizedCurrentPage > normalizedTotalPages) {
            setCurrentPage(normalizedTotalPages);
        }
    }, [normalizedCurrentPage, normalizedTotalPages, setCurrentPage]);

    const updateVisiblePages = (page) => {
        const pages = [];

        if (normalizedTotalPages <= 0) {
            setVisiblePages([]);
            return;
        }

        if (normalizedTotalPages === 1) {
            pages.push(1);
        } else {
            pages.push(1);

            if (page > 3) {
                pages.push("...");
            }

            const startPage = Math.max(2, page - 2);
            const endPage = Math.min(normalizedTotalPages - 1, page + 2);

            for (let i = startPage; i <= endPage; i++) {
                pages.push(i);
            }

            if (page < normalizedTotalPages - 2) {
                pages.push("...");
            }

            pages.push(normalizedTotalPages);
        }

        setVisiblePages(pages);
    };

    const onNext = () => {
        if (typeof setCurrentPage === "function" && !isNextDisabled) {
            setCurrentPage(normalizedCurrentPage + 1);
        }
    };

    const onPrevious = () => {
        if (typeof setCurrentPage === "function" && !isPreviousDisabled) {
            setCurrentPage(normalizedCurrentPage - 1);
        }
    };

    return (
        <div className={`pagination_wrapper ${className}`}>
            <div className="pagination_main">
                <div>
                    <p>Total {totalItems} items</p>
                </div>
                <div className="d-flex align-items-center gap-3">
                    <span
                        onClick={onPrevious}
                        disabled={isPreviousDisabled}
                    >
                        <IoIosArrowBack />
                    </span>
                </div>

                {normalizedTotalPages > 0 && (
                    <div className="pagination_count">
                        <ul>
                            {visiblePages.map((page, index) => (
                                <li
                                    key={`${page}-${index}`}
                                    className={page === normalizedCurrentPage ? "active_page" : ""}
                                    onClick={() => typeof page === "number" && setCurrentPage(page)}
                                >
                                    {page}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="d-flex align-items-center gap-3">
                    <span
                        onClick={onNext}
                        disabled={isNextDisabled}
                    >
                        <IoIosArrowForward />
                    </span>
                </div>

                {
                    showLimit && typeof setLimit === "function" &&
                    <div className="option_select">
                        <select onChange={(e) => setLimit(Number(e.target.value))} value={limit}>
                            {limitOptions.map((opt) => (
                                <option key={opt} value={opt}>
                                    {opt} / page
                                </option>
                            ))}
                        </select>
                    </div>
                }
            </div>
        </div>
    );
};
export default PaginationCustom;
